// extracted by mini-css-extract-plugin
export var arrow = "_35-6";
export var changeItem = "_35-3";
export var changesHeader = "_35-1";
export var changesList = "_35-2";
export var container = "_35-0";
export var pathLabel = "_35-4";
export var value = "_35-7";
export var valuesContainer = "_35-5";